import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import Branding from 'MeetingsBase/models/Branding';

// @ts-expect-error No declaration file for MeetingsLib/selectors/BookInfoSelectors
import { getIsUngatedForBrandingSizingMetadata } from 'MeetingsLib/selectors/BookInfoSelectors';
import { Image } from 'foundations-components/transitional/components/Image';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const GYPSUM = '#f5f8fa';
export const OLAF = '#ffffff';
export const COMPANY_LOGO_USE = {
  EMAIL_FORM: 'email-form',
  BOOKING_CONTAINER: 'booking-container'
};
const CONTAINER_HEIGHT = '92px';
const IMAGE_HEIGHT = '76px';
const CompanyLogo = props => {
  const {
    compact,
    branding: {
      logoUrl,
      logoAltText,
      logoHeight,
      companyName
    },
    heightOverride,
    widthOverride,
    use
  } = props;
  const isUngatedForBrandingSizingMetadata = useSelector(getIsUngatedForBrandingSizingMetadata);
  const [imageHasLoaded, setImageHasLoaded] = useState(false);
  useEffect(() => {
    const imageEl = document.getElementById(`logo-landmark-${use}`);
    const computedImageHeight = imageEl && getComputedStyle(imageEl, null).height;
    if (imageEl && imageHasLoaded) {
      imageEl.style.backgroundColor = use === COMPANY_LOGO_USE.EMAIL_FORM ? OLAF : GYPSUM;
    }
    if (imageEl && imageHasLoaded && computedImageHeight === '0px') {
      imageEl.style.height = IMAGE_HEIGHT;
    }
    if (imageEl && heightOverride && use === COMPANY_LOGO_USE.EMAIL_FORM) {
      imageEl.style.maxHeight = heightOverride || IMAGE_HEIGHT;
    }
    if (imageEl && use === COMPANY_LOGO_USE.BOOKING_CONTAINER && isUngatedForBrandingSizingMetadata) {
      imageEl.style.maxHeight = `${logoHeight}px` || IMAGE_HEIGHT;
    }
  }, [heightOverride, imageHasLoaded, isUngatedForBrandingSizingMetadata, logoHeight, use]);
  const hasLogo = Boolean(logoUrl);
  if (!hasLogo) {
    return null;
  }
  let alt = logoAltText;
  if (!logoAltText) {
    if (companyName) {
      alt = I18n.text('prebook.brandingAltText', {
        companyName
      });
    } else {
      alt = I18n.text('prebook.brandingAltTextNoCompany');
    }
  }
  return /*#__PURE__*/_jsx(View, {
    role: "banner",
    "aria-labelledby": "logo-landmark",
    blockSize: CONTAINER_HEIGHT,
    marginBlockStart: "400",
    marginBlockEnd: compact ? '400' : '0',
    backgroundColor: use === COMPANY_LOGO_USE.EMAIL_FORM ? 'fill-surface-default' : undefined,
    children: /*#__PURE__*/_jsx(Image, {
      maxInlineSize: "100%",
      maxBlockSize: IMAGE_HEIGHT,
      inlineSize: widthOverride || '100%',
      blockSize: "100%",
      "data-test-id": `logo-landmark-${use}`,
      marginInline: "auto",
      objectFit: "contain",
      src: logoUrl,
      alt: alt,
      onLoad: () => {
        setImageHasLoaded(true);
      }
    })
  });
};
CompanyLogo.propTypes = {
  compact: PropTypes.bool,
  branding: PropTypes.instanceOf(Branding).isRequired,
  use: PropTypes.string,
  heightOverride: PropTypes.string
};
export default CompanyLogo;